<template lang="pug">
v-btn(
    v-show="btnScrollToTop"
    key="btn-scroll-to-top"
    v-scroll="onScroll"
    title="Scroll to top"
    fab 
    dark 
    fixed 
    bottom 
    right 
    small
    color="primary"
    style="opacity: 0.7;" @click="scrollToTop"
  )
    v-icon mdi-chevron-up
</template>

<script>
export default {
  name: "ButtonScrollToTop",
  data() {
    return {
      btnScrollToTop: false,
    };
  },
  methods: {
    onScroll(event) {
      if (typeof window === "undefined") return;
      const top = window.scrollY || event.target.scrollTop || 0;
      this.btnScrollToTop = top > 300;
    },
    scrollToTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>

<style lang="sass" scoped>
.btn-enter-active, .btn-leave-active
  transition: opacity 0.5s ease

.btn-enter-from, .btn-leave-to
  opacity: 0
</style>
